'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['message'],
    computed: {
        colour: function colour() {
            return this.message.user ? this.message.user.getColour() : '';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListAvatar"]
window._kiwi_exports.components.MessageListAvatar = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageListAvatar.vue
// module id = D2nl
// module chunks = 1